import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Offcanvas, Nav } from "react-bootstrap";
// removed search icon
import { FaBars } from "react-icons/fa"; 



const CareerNav = () => {
  const [show, setShow] = useState(false);
  // search removed from navbar

  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <div className='w-full border-b border-black-700'>
      <div className='w-full'>
        <div className='flex items-center justify-between px-4 py-2'>
          <div className='flex items-center gap-3'>
            <Link to='/' className='text-decoration-none'>
              <h3
                className='text-black'
                style={{ fontFamily: "Gilroy-SemiBold" }}
              >
                avijobs
              </h3>
            </Link>

            <Link
              to='/joblistings'
              target='Blank'
              className='text-decoration-none text-black ml-4'
              style={{ fontFamily: "Gilroy-SemiBold" }}
            >
              Career
            </Link>
            
            
            <Link
              to='/support'
              className='text-decoration-none text-black'
              style={{ fontFamily: "Gilroy-SemiBold" }}
            >
              Benefit
            </Link>
            <div className='relative'>
              <Button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className='flex items-center gap-2 border-none text-black'
                style={{
                  backgroundColor: "white",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <span color='black' style={{ fontFamily: "Gilroy-SemiBold" }}>
                 Culture
                </span>
                <svg
                  className={`transition-transform ${dropdownOpen ? "rotate-180" : ""} mt-2`}
                  width='12'
                  height='8'
                  viewBox='0 0 12 8'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M1 1L6 6L11 1'
                    stroke='black'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </Button>
              {dropdownOpen && (
                <ul
                  className='absolute right-0 mt-2 w-48 rounded-lg border border-gray-300 bg-white shadow-lg'
                  style={{ fontFamily: "Gilroy-SemiBold" }}
                >
                  <a
                    href='/culture'
                    className='block px-4 py-2 text-gray-800 hover:bg-gray-100'
                  >
                    Culture
                  </a>
                  <a
                    href='/diversity'
                    className='block px-4 py-2 text-gray-800 hover:bg-gray-100'
                  >
                    Diversity
                  </a>
                  <a
                    href='/leadership'
                    className='block px-4 py-2 text-gray-800 hover:bg-gray-100'
                  >
                    LeaderShip
                  </a>
                </ul>
              )}
            </div>
            <Link
              to='/hiring-tips'
              className='text-decoration-none text-black'
              style={{ fontFamily: "Gilroy-SemiBold" }}
            >
              Hiring Tips
            </Link>
            <Link
              to='/certificate-validation'
              className='text-decoration-none text-black'
              style={{ fontFamily: "Gilroy-SemiBold" }}
            >
              Certificate Validation
            </Link>
          </div>
          <div className='flex items-center gap-3'>
                  {/* search removed */}
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerNav;
